import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { Nullable } from 'clickNgo/models/utils'
import { updateFormData } from 'cng-common/features/form'
import { ActualsValueTypes, DEFAULT_NETNDP_QBR } from 'partner360/models/actualValueTypes'

import { QBR_SETTINGS_FORM_KEY } from '../../../components/QBR/components/qbrDocumentDetails/components/steps/settingsStep/components/qbrSettingsForm'
import { IQbrSettingsForm } from '../../../components/QBR/components/qbrDocumentDetails/components/steps/settingsStep/components/qbrSettingsForm/models/qbrSettingsForm'
import { IParsedSettingsFromQBRDocumentsListItem } from '../../../models/qbr/IParsedSettingsFromQBRDocumentsListItem'
import { createDraftQbr } from '../api/createDraftQbr'
import { DEFAULT_CURRENCY, DEFAULT_ELT_VERSION, DEFAULT_ROUNDING, DEFAULT_SLIDES } from '../configs'
import { changeQBRCurrencyOptions, changeQBRNetNdpOptions } from '../QBRSlice'

listenerMiddleware.startListening({
  actionCreator: createDraftQbr.fulfilled,
  effect: (action, { dispatch }) => {
    const { qbrDraft } = action.payload

    const settings: Nullable<IParsedSettingsFromQBRDocumentsListItem> = qbrDraft.Settings
      ? JSON.parse(qbrDraft.Settings)
      : null

    const initialFormData: IQbrSettingsForm = {
      name: qbrDraft.Name || '',
      currency: settings?.SelectedCurrency || DEFAULT_CURRENCY,
      offerings: settings?.SelectedOfferings || [],
      netNdp: (settings?.SelectedNetNdp as ActualsValueTypes) || DEFAULT_NETNDP_QBR,
      rounding: settings?.SelectedRounding || DEFAULT_ROUNDING,
      selectedPeriodFYear: settings && settings.Quarters ? settings.Quarters.Selected[0].FYear : 0,
      selectedPeriodFQuarters:
        settings && settings.Quarters
          ? settings.Quarters.Selected[0].FQuarters.map((it) => it.FQuarter)
          : [],
      exportSlides: settings?.ExportSlides || DEFAULT_SLIDES,
      eltVersion: settings?.ELTVersion || DEFAULT_ELT_VERSION,
      isGlobalPlans: settings?.IsGlobalPlans ?? null,
    }

    dispatch(changeQBRNetNdpOptions(settings?.NetNdp || []))
    dispatch(changeQBRCurrencyOptions(settings?.Currency || []))

    dispatch(
      updateFormData({
        formKey: QBR_SETTINGS_FORM_KEY,
        formData: initialFormData,
      })
    )
  },
})
